import Repository from "@/api/repository";
const resourceCustomFields = `/notification/customfields`;
export default {
    getNotificationCustomFields() {
        return Repository.get(`${resourceCustomFields}`);
    }
};
